import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { id: "projects" }
const _hoisted_3 = { id: "projects-zh-section" }
const _hoisted_4 = { id: "projects-en-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", null, "项目", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectsRecordsDetailCN, (value, key) => {
          return (_openBlock(), _createElementBlock("div", { key: key }, [
            _createElementVNode("h3", null, _toDisplayString(key), 1),
            _createElementVNode("ol", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item) => {
                return (_openBlock(), _createElementBlock("ul", { key: item }, _toDisplayString(item), 1))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Projects", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectsRecordsDetailEN, (value, key) => {
          return (_openBlock(), _createElementBlock("div", { key: key }, [
            _createElementVNode("h3", null, _toDisplayString(key), 1),
            _createElementVNode("ol", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item) => {
                return (_openBlock(), _createElementBlock("ul", { key: item }, _toDisplayString(item), 1))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}